
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetogiaertigaonrent() {



    const cardData =
    {
        keyword: ' Pune to Goa Ertiga on Rent',
        heading: 'Prince Cabs: Pune to Goa Ertiga on Rent',
        headingDescription: 'Prince Cabs offers convenient Pune to Goa Ertiga on Rent, perfect for family holidays, beach vacations, corporate trips, and weekend getaways. Our spacious and well-maintained Ertiga cars provide a safe, comfortable, and budget-friendly ride along the scenic Konkan route. With professional chauffeurs, flexible booking options, and on-time pickups, we make your Pune to Goa journey smooth and stress-free. Experience comfort, reliability, and affordability with Prince Cabs’ trusted Ertiga rental service from Pune to Goa.',

        top: 'Top Places to Visit in Goa with Prince Cabs',

"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is one of Goa’s most vibrant and happening beaches, famous for nightlife, beach parties, and water sports. Shacks serve delicious seafood while music fills the air. Visitors enjoy parasailing, banana rides, and jet skiing. Tito’s and Mambo’s nightclubs nearby make it a party hub. The beach is crowded with both domestic and international tourists. Baga is Goa’s symbol of fun and excitement."
  },
  {
    "title": "Calangute Beach",
    "description": "Calangute, known as the ‘Queen of Beaches,’ is the largest beach in North Goa. It attracts thousands of tourists for its golden sand, lively shacks, and shopping stalls. Water sports like parasailing and windsurfing are popular here. The beach has a festive atmosphere during peak season. Souvenir shops sell handicrafts, clothes, and jewelry. Calangute is the heart of Goa’s beach culture."
  },
  {
    "title": "Anjuna Beach",
    "description": "Anjuna Beach is famous for its hippie vibe, flea markets, and trance parties. Every Wednesday, the flea market sells clothes, jewelry, and handicrafts from across India. The rocky shoreline adds to its charm. Tourists love the beach parties that continue late into the night. Its history with the hippie movement of the 1960s still lingers. Anjuna is Goa’s bohemian paradise."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach in South Goa is a crescent-shaped beach known for its calm waters and scenic beauty. It is perfect for swimming, kayaking, and dolphin-spotting boat rides. Beach huts and yoga retreats create a laid-back vibe. Sunsets at Palolem are breathtakingly beautiful. It is less crowded compared to North Goa’s beaches. Palolem is ideal for relaxation and natural charm."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Falls, located on the Goa-Karnataka border, is one of India’s tallest waterfalls. The name means ‘Sea of Milk’ due to its white frothy cascades. Surrounded by Bhagwan Mahaveer Sanctuary, it is accessible via jeep safaris and treks. The falls are most spectacular during monsoon. Bollywood fans remember it from the movie ‘Chennai Express.’ Dudhsagar is Goa’s natural wonder."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus, a UNESCO World Heritage Site, is Goa’s most famous church. Built in 1605, it houses the mortal remains of St. Francis Xavier. The baroque architecture and intricate altars attract pilgrims and tourists alike. Its spiritual importance makes it a global Christian landmark. The church hosts festivals and exhibitions annually. It is Goa’s timeless heritage treasure."
  },
  {
    "title": "Se Cathedral",
    "description": "Se Cathedral, located in Old Goa, is one of the largest churches in Asia. Built in Portuguese-Gothic style, it is dedicated to St. Catherine. The cathedral’s golden bell is the largest in Goa. Its interiors are adorned with altars and paintings. Visitors admire its vast size and religious significance. Se Cathedral reflects Goa’s colonial and Christian heritage."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada, built by the Portuguese in 1612, is a well-preserved seaside fort overlooking the Arabian Sea. It once guarded against Dutch and Maratha invasions. The fort also has a lighthouse, one of the oldest in Asia. Tourists enjoy panoramic sea views from its ramparts. Its history and scenic setting make it a popular attraction. Fort Aguada is Goa’s coastal sentinel."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort, made famous by the Bollywood movie ‘Dil Chahta Hai,’ is a popular hangout spot. Located above the Chapora River, it offers stunning views of Vagator Beach and the Arabian Sea. The ruins of the fort add historic charm. Sunset views from here are breathtaking. Backpackers and youngsters love its casual vibe. Chapora Fort is Goa’s cinematic and scenic hotspot."
  },
  {
    "title": "Colva Beach",
    "description": "Colva Beach in South Goa is famous for its white sand and peaceful setting. It is one of the oldest and longest beaches in the state. Families enjoy swimming, sunbathing, and seafood at local shacks. Water sports like speed boating and parasailing are also available. The nearby Our Lady of Mercy Church adds cultural charm. Colva is South Goa’s classic beach destination."
  },
  {
    "title": "Arambol Beach",
    "description": "Arambol Beach is known for its bohemian vibe and relaxed atmosphere. It attracts backpackers, yoga enthusiasts, and artists from across the globe. Drum circles and live music sessions light up the evenings. The nearby sweet water lake and cliffs add natural beauty. It is less commercialized, retaining its rustic charm. Arambol is Goa’s soulful beach escape."
  },
  {
    "title": "Miramar Beach",
    "description": "Miramar Beach, located near Panaji, is a popular hangout for locals and tourists. Its golden sand and calm waters make it great for evening strolls. The beach is close to Dona Paula and many city attractions. It offers lovely views of the Arabian Sea. Families love the relaxed vibe of Miramar. It is Panaji’s most convenient beach getaway."
  },
  {
    "title": "Mangueshi Temple",
    "description": "Mangueshi Temple in Ponda is one of Goa’s most revered Hindu temples. Dedicated to Lord Shiva, it features a seven-story lamp tower and traditional Goan architecture. The temple is surrounded by lush greenery and a peaceful atmosphere. Festivals like Shivratri are celebrated with grandeur. Devotees visit from across India to seek blessings. Mangueshi Temple is Goa’s spiritual landmark."
  },
  {
    "title": "Dona Paula Viewpoint",
    "description": "Dona Paula Viewpoint is a romantic spot where the Mandovi and Zuari rivers meet the Arabian Sea. Legends of Dona Paula’s love story add mystique to the place. The viewpoint offers stunning sea views and water sports options. Bollywood movies have been shot here. It is especially popular for sunsets and breezy evenings. Dona Paula is Goa’s most romantic attraction."
  },
  {
    "title": "Spice Plantations",
    "description": "Goa’s spice plantations in Ponda offer a unique cultural and nature experience. Visitors tour plantations of cardamom, pepper, nutmeg, and cashew. Guides explain traditional farming methods and spice benefits. Guests enjoy Goan meals served on banana leaves. Elephant rides and birdwatching are additional attractions. Spice plantations are Goa’s aromatic countryside escape."
  }
],

"services": [
  {
    "name": "Pune to Goa Ertiga Cab Booking",
    "description": "Book a reliable Ertiga cab from Pune to Goa for a smooth and enjoyable journey along the scenic route. Ideal for families and groups, this 7-seater ensures comfortable seating, air-conditioning, and a safe travel experience with an experienced driver. Whether it’s a vacation or a weekend escape, this service offers timely pickups, easy booking, and flexible trip planning tailored to your travel needs."
  },
  {
    "name": "Ertiga for Goa Tour from Pune",
    "description": "Hire an Ertiga for a fun-filled Goa tour starting from Pune. With ample space, great suspension, and a professional chauffeur, the vehicle is perfect for long trips. Enjoy sightseeing, beach hopping, and a worry-free ride with comfortable interiors and ample luggage room, making it the best option for groups of 5–6 people heading on a coastal adventure."
  },
  {
    "name": "Pune to Goa Ertiga Rental",
    "description": "Get an Ertiga on rent for your Pune to Goa trip and enjoy unmatched comfort and convenience on your journey. This 7-seater car is known for fuel efficiency and ride stability, making it an excellent choice for long-distance travel. Whether you're going for leisure or attending an event, our rental includes a courteous driver and competitive pricing."
  },
  {
    "name": "Family Car Pune to Goa",
    "description": "Choose a family-friendly Ertiga car for your Pune to Goa travel and experience a safe, spacious, and cozy ride. The vehicle accommodates up to 6 passengers and provides generous legroom, clean interiors, and a smooth ride, making it ideal for families with kids or elderly members. Travel with ease and enjoy the scenic route to Goa with all your loved ones."
  },
  {
    "name": "7 Seater Ertiga Pune to Goa",
    "description": "Opt for a 7-seater Ertiga taxi from Pune to Goa for maximum comfort during your intercity trip. Equipped with air conditioning, spacious seats, and enough space for luggage, this cab is perfect for groups, family travel, or weekend getaways. Our trained drivers ensure safety and punctuality, giving you peace of mind throughout your journey."
  },
  {
    "name": "Pune to Goa Outstation Ertiga Taxi",
    "description": "Book an outstation Ertiga taxi from Pune to Goa for a seamless travel experience across state lines. Our outstation services include transparent pricing, well-maintained vehicles, and reliable drivers who are familiar with the route. Whether you're traveling for business or leisure, this option gives you the right blend of comfort, convenience, and affordability."
  },
  {
    "name": "Pune to Goa Ertiga One Way",
    "description": "Looking for a one-way drop from Pune to Goa? Our Ertiga one-way cab offers a cost-effective and convenient solution for travelers. No return fare required — just pay for your journey to Goa. Perfect for solo travelers, families, or groups who have separate return arrangements or plan to stay longer in Goa."
  },
  {
    "name": "Affordable Ertiga Pune to Goa",
    "description": "Travel affordably from Pune to Goa with our budget-friendly Ertiga cab services. This 7-seater vehicle offers premium comfort at low rates, making it an excellent choice for travelers who want value without compromising on ride quality or service standards. Ideal for students, families, and group travelers."
  },
  {
    "name": "Pune to Goa Ertiga Crysta Hire",
    "description": "Hire a premium Ertiga Crysta for your Pune to Goa trip and enjoy upgraded interiors, smooth handling, and extra legroom. This is a luxury-level MPV experience for those who want to elevate their long road journey without choosing a bulky SUV. Great for business executives, wedding travel, and special occasions."
  },
  {
    "name": "Pune to Goa SUV Ertiga Cab",
    "description": "Experience the utility of an SUV-style ride with our Ertiga cab service from Pune to Goa. Designed for performance, safety, and comfort, this vehicle is ideal for rougher terrain, winding roads, and long distances — a smart choice for travelers heading to Goa’s beaches, resorts, or interior destinations."
  },
  {
    "name": "Ertiga for Group Trip Pune to Goa",
    "description": "Planning a group trip from Pune to Goa? Our Ertiga cabs provide the perfect balance of space, comfort, and affordability for groups of up to 6 passengers. With roomy interiors, courteous drivers, and on-time service, it’s a top pick for road trips, college outings, and friends’ getaways."
  },
  {
    "name": "Long Distance Cab Ertiga Pune to Goa",
    "description": "Book a long-distance cab from Pune to Goa in an Ertiga for a hassle-free travel experience. With great fuel efficiency, plush seating, and AC comfort, the Ertiga is made for longer routes. Drivers are trained for highway driving and help ensure a pleasant ride over several hours of travel."
  },
  {
    "name": "Pune to Goa Wedding Trip Ertiga",
    "description": "Travel to a wedding event in Goa from Pune with our comfortable Ertiga cab. Perfect for carrying guests, family members, or even bridal parties, the Ertiga provides spacious seating and smooth rides for a stress-free celebration trip. Timely service, neat interiors, and courteous drivers are included."
  },
  {
    "name": "Pune to Goa AC Ertiga",
    "description": "Stay cool and relaxed on your Pune to Goa journey with our AC-equipped Ertiga cabs. Regardless of weather or season, this vehicle ensures a pleasant environment throughout the drive, with ample airflow, clean upholstery, and all-round comfort for every passenger on board."
  },
  {
    "name": "Comfortable Ertiga Cab Pune to Goa",
    "description": "Enjoy ultimate comfort on your trip from Pune to Goa with our Ertiga cab service. Designed for long rides, this vehicle offers ergonomic seating, smooth suspension, and ample legroom. Ideal for travelers who prioritize comfort, safety, and a peaceful driving experience over long distances."
  }
],
"tableData": [
  ["Pune to Goa Ertiga Cab Booking", "Ertiga for Goa Tour from Pune"],
  ["Pune to Goa Ertiga Rental", "Family Car Pune to Goa"],
  ["7 Seater Ertiga Pune to Goa", "Pune to Goa Outstation Ertiga Taxi"],
  ["Pune to Goa Ertiga One Way", "Affordable Ertiga Pune to Goa"],
  ["Pune to Goa Ertiga Crysta Hire", "Pune to Goa SUV Ertiga Cab"],
  ["Ertiga for Group Trip Pune to Goa", "Long Distance Cab Ertiga Pune to Goa"],
  ["Pune to Goa Wedding Trip Ertiga", "Pune to Goa AC Ertiga"],
  ["Comfortable Ertiga Cab Pune to Goa"]
],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable Ertiga on Rent from Pune to Goa",
    "WhyChoosedescription": "Prince Cabs offers a reliable and spacious Ertiga on rent for your Pune to Goa journey. Whether you're traveling with family or a group of friends, our 7-seater Ertiga provides the perfect balance of comfort, space, and affordability for your long-distance road trip. Enjoy a smooth, scenic, and safe journey across the Western Ghats and coastal highways with our well-maintained vehicles and experienced drivers."
  },
  {
    "WhyChooseheading": "Ideal Vehicle for Long-Distance Group Travel",
    "WhyChoosedescription": "The Maruti Ertiga is a popular choice for Pune to Goa trips due to its spacious interiors, adjustable seating for up to 6 passengers + driver, and ample luggage space. With strong air conditioning, reclining seats, and great fuel efficiency, it ensures a relaxed and enjoyable journey — especially for overnight or multi-day travel plans."
  },
  {
    "WhyChooseheading": "Flexible One-Way & Round-Trip Rental Packages",
    "WhyChoosedescription": "We offer customized rental plans for one-way trips, same-day returns, or extended stays in Goa. Whether you’re heading to North Goa beaches, South Goa resorts, or any offbeat location, we’ve got you covered with transparent pricing and complete flexibility in scheduling and return options."
  },
  {
    "WhyChooseheading": "Professional Drivers with Route Expertise",
    "WhyChoosedescription": "Our trained and courteous drivers are highly experienced on the Pune to Goa route, familiar with the best roads, food stops, and travel timings. They ensure your safety while also helping you enjoy the journey. We schedule proper rest breaks to keep the trip comfortable for all passengers."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Our Pune to Goa Ertiga rental fares are inclusive of fuel, tolls, driver allowances, and taxes. There are no hidden charges — you pay only what’s quoted. We provide all fare details upfront and accept multiple payment modes such as UPI, cards, net banking, and cash for convenience."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Trip-Ready Vehicles",
    "WhyChoosedescription": "All Ertiga vehicles are cleaned and sanitized before every trip. They undergo regular maintenance checks to ensure mechanical reliability. Safety features like airbags, ABS, and seat belts are standard in every car, giving you and your loved ones complete peace of mind on the long road trip."
  },
  {
    "WhyChooseheading": "24/7 Booking Support and On-Trip Assistance",
    "WhyChoosedescription": "Our customer care team is available 24x7 to assist you with bookings, itinerary changes, or any issues during your journey. Whether you're booking in advance or need a last-minute ride to Goa from Pune, Prince Cabs ensures complete support from start to finish."
  }
]





















    }

const faqData = [
    {
        question: 'Can I rent an Ertiga for a Pune to Goa trip with Prince Cabs?',
        answer: 'Yes, Prince Cabs offers spacious and comfortable Ertiga rentals for one-way and round trips between Pune and Goa.',
    },
    {
        question: 'Is the Ertiga suitable for long-distance travel like Pune to Goa?',
        answer: 'Absolutely! The Ertiga is ideal for long road trips with its ample legroom, luggage space, and comfortable seating for up to 6 passengers.',
    },
    {
        question: 'Are the Ertiga cabs well-maintained and sanitized?',
        answer: 'Yes, all Ertiga vehicles are thoroughly cleaned, sanitized, and maintained to ensure a safe and pleasant journey.',
    },
    {
        question: 'Does the Ertiga rental include a driver for Pune to Goa trips?',
        answer: 'Yes, all Ertiga rentals come with an experienced and courteous driver to make your Pune to Goa travel stress-free.',
    },
    {
        question: 'What is the fare for renting an Ertiga from Pune to Goa?',
        answer: 'Fares depend on whether it’s a one-way or round trip, travel duration, and season. Please contact Prince Cabs for a custom quote.',
    },
    {
        question: 'Can I book a round trip to Goa with an Ertiga?',
        answer: 'Yes, Prince Cabs offers flexible round-trip packages with Ertiga rentals from Pune to Goa at competitive rates.',
    },
    {
        question: 'How do I book an Ertiga on rent from Pune to Goa?',
        answer: 'Booking is easy—visit our website or call our customer support to confirm your Pune to Goa Ertiga rental in minutes.',
    },
];

const testimonials = [
    {
        name: "Mr. Rohan Kamat",
        position: "Adventure Traveler",
        text: "We rented an Ertiga from Pune to Goa with Prince Cabs. The ride was smooth, the driver was great, and the trip was unforgettable.",
        image: "/img/testimonial/testimonial-thumb-ertiga-pune-goa-1.png",
    },
    {
        name: "Ms. Meenal Joshi",
        position: "Group Traveler",
        text: "Prince Cabs made our Pune to Goa journey super comfortable with a well-maintained Ertiga. Highly recommended for group trips!",
        image: "/img/testimonial/testimonial-thumb-ertiga-pune-goa-2.png",
    },
];















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Goa Ertiga on Rent",
  "description": "Book affordable 7 Seater Ertiga cabs from Pune to Goa for family trips, group tours, wedding travel, and comfortable long-distance rides with AC.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Goa Ertiga Cab Booking",
    "Ertiga for Goa Tour from Pune",
    "Pune to Goa Ertiga Rental",
    "Family Car Pune to Goa",
    "7 Seater Ertiga Pune to Goa",
    "Pune to Goa Outstation Ertiga Taxi",
    "Pune to Goa Ertiga One Way",
    "Affordable Ertiga Pune to Goa",
    "Pune to Goa Ertiga Crysta Hire",
    "Pune to Goa SUV Ertiga Cab",
    "Ertiga for Group Trip Pune to Goa",
    "Long Distance Cab Ertiga Pune to Goa",
    "Pune to Goa Wedding Trip Ertiga",
    "Pune to Goa AC Ertiga",
    "Comfortable Ertiga Cab Pune to Goa"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Goa Ertiga on Rent | Affordable 7 Seater Cab Booking</title>
  <meta
    name="description"
    content="Book affordable 7 Seater Ertiga cabs from Pune to Goa for family trips, group tours, wedding travel, and comfortable long-distance rides with AC."
  />
  <meta
    name="keywords"
    content="Pune to Goa Ertiga Cab Booking, Ertiga for Goa Tour from Pune, Pune to Goa Ertiga Rental, Family Car Pune to Goa, 7 Seater Ertiga Pune to Goa, Pune to Goa Outstation Ertiga Taxi, Pune to Goa Ertiga One Way, Affordable Ertiga Pune to Goa, Pune to Goa Ertiga Crysta Hire, Pune to Goa SUV Ertiga Cab, Ertiga for Group Trip Pune to Goa, Long Distance Cab Ertiga Pune to Goa, Pune to Goa Wedding Trip Ertiga, Pune to Goa AC Ertiga, Comfortable Ertiga Cab Pune to Goa"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/75.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogiaertigaonrent ;